import { render } from "./DropDownListTipoMovimentacao.vue?vue&type=template&id=486ac110&ts=true"
import script from "./DropDownListTipoMovimentacao.vue?vue&type=script&lang=ts"
export * from "./DropDownListTipoMovimentacao.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__